import React from 'react';
import { Box, Typography } from '@mui/material';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { useShellNav } from '../ShellNavContext';
import { shellSx, shellTokens } from '../theme/shellTheme';

const MORE_TILES = [
    { destination: 'research', label: 'Research', Icon: ScienceOutlinedIcon },
    { destination: 'admin', label: 'Admin', Icon: SettingsOutlinedIcon },
    { destination: 'docs', label: 'Docs', Icon: DescriptionOutlinedIcon },
];

const MorePage = () => {
    const { setDestination } = useShellNav();

    return (
        <Box>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.5 }}>
                More
            </Typography>
            <Typography variant="body2" sx={{ color: shellTokens.muted, mb: 2 }}>
                Research, admin, and documentation destinations.
            </Typography>
            <Box sx={{ ...shellSx.panel, mb: 2 }}>
                <Box sx={{ p: 2, borderBottom: `1px solid ${shellTokens.border}` }}>
                    <Typography sx={{ fontSize: '0.62rem', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: shellTokens.muted }}>
                        Extended
                    </Typography>
                    <Typography sx={{ fontWeight: 700, fontSize: '0.92rem', mt: 0.25 }}>
                        Research · Admin · Docs
                    </Typography>
                </Box>
                <Box
                    sx={{
                        p: 2,
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
                        gap: 1.25,
                    }}
                >
                    {MORE_TILES.map(({ destination, label, Icon }) => (
                        <Box
                            key={destination}
                            component="button"
                            type="button"
                            onClick={() => setDestination(destination)}
                            sx={{
                                border: `1px solid ${shellTokens.border}`,
                                borderRadius: `${shellTokens.innerRadius}px`,
                                p: 2,
                                bgcolor: shellTokens.surface,
                                cursor: 'pointer',
                                textAlign: 'center',
                                fontSize: '0.82rem',
                                fontWeight: 600,
                                color: shellTokens.text,
                                fontFamily: 'inherit',
                                '&:hover': { bgcolor: 'rgba(15, 23, 42, 0.03)' },
                            }}
                        >
                            <Icon sx={{ fontSize: '1.4rem', mb: 0.75, color: shellTokens.muted }} />
                            <Box>{label}</Box>
                        </Box>
                    ))}
                </Box>
            </Box>
            <Box sx={{ ...shellSx.panel, p: 2, fontSize: '0.78rem', color: shellTokens.muted, lineHeight: 1.7 }}>
                <Typography sx={{ fontSize: '0.62rem', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: shellTokens.muted, mb: 0.5 }}>
                    Retired top-level tabs
                </Typography>
                <Typography component="div" sx={{ fontSize: '0.78rem', color: shellTokens.muted }}>
                    qCockpit · Trading Cockpit · Diagnostics → <strong>Strategies</strong>
                    <br />
                    pHealth · iHealth → <strong>Platform</strong>
                    <br />
                    Positions · Funds · Trading Hub · Option Chain → <strong>Trade</strong>
                    <br />
                    HFT · Tick · Screeners → <strong>Research</strong>
                    <br />
                    Control · Config · Lots → <strong>Admin</strong>
                </Typography>
            </Box>
        </Box>
    );
};

export default MorePage;
